<tyl-kendo-pdf-export [keepTogether]="'.mat-row'" class="tylKendoPdf">
    <div #studentHeader class="flex-header" *ngIf="courseRequestYear || counselor">
        <student-header [pageTitle]="'Course Requests'"
            [showYearSelector]="true"
            [courseRequestYear]="counselor ? null : courseRequestYear"></student-header>
    </div>
    <div class="flex-content" style="padding-left: 10px;">
        <div style="text-align:center; width: 100%;" *ngIf="studentCourseRequests && studentCourseRequests.length == 0"
            translate>
            No Course requirement data exists.
        </div>
        <div *ngIf="studentCourseRequests && studentCourseRequests.length > 0">
            <table style="font-weight:bold;width: 100%;" *ngIf="overAllRequirement">
                <tr>
                    <td style="padding:0px;" style="width: 20%;white-space: nowrap; padding-left: 20px;" translate>
                        Overall Requirements
                    </td>
                    <td style="padding:0px;" style="width: 15%;white-space: nowrap;padding-left: 10px;" translate>Min
                        Credits
                        <span
                            [ngStyle]="{'background-color':overAllRequirement.HighlightOverallMinCredit==true ? '#ffff8d' : '#ffffff'}"
                            style="padding: 5px 10px;">
							{{overAllRequirement.ReqMinCredits}}</span>
                    </td>
                    <td style="padding:0px;" style="width: 15%;white-space: nowrap;padding-left: 10px;" translate>Max
                        Credits
                        <span style="padding: 5px 10px;"
                            [ngStyle]="{'background-color':overAllRequirement.HighlightOverallMaxCredit==true ? '#ffff8d' : '#ffffff', 'color': overAllRequirement.ReqMaxCredits == 0 ? 'lightgray' : 'black' }">
							{{overAllRequirement.ReqMaxCredits == 0 ? "N/A" : overAllRequirement.ReqMaxCredits }}</span>
                    </td>
                    <td style="padding:0px;" style="width: 15%;white-space: nowrap;padding-left: 10px;" translate>
                        Requested Credits
                        <span style="padding: 5px 10px;"
                            [ngStyle]="{'background-color': overAllRequirement.HighlightOverallMinCredit==true || overAllRequirement.HighlightOverallMaxCredit==true ? '#ffff8d' : '#ffffff'}">{{overAllRequirement.RequestedCredits}}
						</span>
                    </td>
                    <td style="padding:0px;" style="width: 15%;white-space: nowrap;padding-left: 10px;" translate>Min
                        Courses
                        <span style="padding: 5px 10px;"
                            [ngStyle]="{'background-color':overAllRequirement.HighlightOverallMinCourses==true ? '#ffff8d' : '#ffffff', 'color': overAllRequirement.ReqMinCourses ? 'black' : 'lightgray' } ">
							{{overAllRequirement.ReqMinCourses ? overAllRequirement.ReqMinCourses : "N/A" }}</span>
                    </td>
                    <td style="padding:0px;" style="width: 15%;white-space: nowrap;padding-left: 10px;" translate>Max
                        Courses
                        <span style="padding: 5px 10px;"
                            [ngStyle]="{'background-color':overAllRequirement.HighlightOverallMaxCourses==true ? '#ffff8d' : '#ffffff', 'color': overAllRequirement.ReqMaxCourses ? 'black' : 'lightgray' }">
							{{overAllRequirement.ReqMaxCourses ? overAllRequirement.ReqMaxCourses : "N/A" }}</span>
                    </td>
                    <td style="padding:0px;" style="width: 15%;white-space: nowrap;padding-left: 10px;" translate>
                        Requested Courses
                        <span style="padding: 5px 10px;"
                            [ngStyle]="{'background-color': overAllRequirement.HighlightOverallMinCourses==true || overAllRequirement.HighlightOverallMaxCourses==true ? '#ffff8d' : '#ffffff'}">{{overAllRequirement.RequestedCourses}}
						</span>
                    </td>
                    <td style="padding:0px;" style="width: 60%"><span>&nbsp;</span></td>
                </tr>
            </table>
            <div style="overflow: auto;" [ngStyle]="{'height':gridHeight+'px'}">
                <table mat-table [dataSource]="courseRequesrRequirementSource" multiTemplateDataRows
                    style="width: 100%">
                    <ng-container matColumnDef="RequirementName">
                        <th style="padding:0px;min-width: 250px;max-width: 250px;" mat-header-cell *matHeaderCellDef
                            translate> Course Requirement
                        </th>
                        <td style="padding-left:0px;padding-right: 10px;border:none;" mat-cell
                            *matCellDef="let element;let i = dataIndex"
                            [attr.rowspan]="getRowSpan(element)" [attr.colspan]="element.RowNumber > 1  ? '7' : '1'"
                            [style.display]="element.RowNumber < 3 ? '' : 'none'"
                            [ngStyle]="{'vertical-align': element.RowNumber > 1 ? 'top' : 'middle','min-width': element.RowNumber == 2 ? '490px' : '250px','max-width': element.RowNumber == 2 ? '490px' : '250px' }">
                            <span *ngIf="element.RowNumber == 1">{{element.RequirementName}} </span>
                            <span *ngIf="element.RowNumber == 2">{{element.RequirementInstructions}} </span>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="ReqMinCredits">
                        <th style="padding:0px;min-width: 80px;max-width: 80px;" mat-header-cell *matHeaderCellDef
                            translate> Min Credits
                        </th>
                        <td style="padding:0px;min-width: 80px;max-width: 80px;border:none;" mat-cell
                            *matCellDef="let element;let i = dataIndex"
                            [attr.rowspan]="getRowSpan(element)" [style.display]="element.RowNumber > 1  ? 'none' : ''">
                            <div [ngStyle]="{'background-color':element.HighlightMinCredit==true ? '#ffff8d' : ''}"
                                style="height: 40px;width: 40px;text-align: center;padding-top: 10px;">
                                {{element.ReqMinCredits}}
                            </div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="ReqMaxCredits">
                        <th style="padding:0px;min-width: 80px;max-width: 80px;" mat-header-cell *matHeaderCellDef
                            translate> Max Credits
                        </th>
                        <td style="padding:0px;min-width: 80px;max-width: 80px;border:none;" mat-cell
                            *matCellDef="let element;let i = dataIndex"
                            [attr.rowspan]="getRowSpan(element)" [style.display]="element.RowNumber > 1 ? 'none' : ''">
                            <div
                                [ngStyle]="{'background-color':element.HighlightMaxCredit==true ? '#ffff8d' : '', 'color': element.ReqMaxCredits == 0 ? 'lightgray' : 'black' }"
                                style="height: 40px;width: 40px;text-align: center;padding-top: 10px;">
                                {{element.ReqMaxCredits == 0 ? "N/A" : element.ReqMaxCredits }}
                            </div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="RequestedCredits">
                        <th style="padding:0px;min-width: 80px;max-width: 80px;" mat-header-cell *matHeaderCellDef
                            translate> Requested Credits
                        </th>
                        <td style="padding:0px;min-width: 80px;max-width: 80px;" mat-cell
                            *matCellDef="let element;let i = dataIndex"
                            [attr.rowspan]="getRowSpan(element)" [style.display]="element.RowNumber > 1 ? 'none' : ''">
                            <div
                                [ngStyle]="{'background-color':element.HighlightMinCredit==true || element.HighlightMaxCredit==true ? '#ffff8d' : ''}"
                                style="height: 40px;width: 40px;text-align: center;padding-top: 10px;">
                                {{element.RequestedCredits}}
                            </div>

                        </td>
                    </ng-container>
                    <ng-container matColumnDef="ReqMinCourses">
                        <th style="padding:0px;min-width: 80px;max-width: 80px;" mat-header-cell *matHeaderCellDef
                            translate> Min Courses
                        </th>
                        <td style="padding:0px;min-width: 80px;max-width: 80px;border:none;" mat-cell
                            *matCellDef="let element;let i = dataIndex"
                            [attr.rowspan]="getRowSpan(element)" [style.display]="element.RowNumber > 1  ? 'none' : ''">
                            <div
                                [ngStyle]="{'background-color':element.HighlightMinCourses==true ? '#ffff8d' : '', 'color': element.ReqMinCourses ? 'black' : 'lightgray' }"
                                style="height: 40px;width: 40px;text-align: center;padding-top: 10px;">
                                {{element.ReqMinCourses ? element.ReqMinCourses : "N/A"}}
                            </div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="ReqMaxCourses">
                        <th style="padding:0px;min-width: 80px;max-width: 80px;" mat-header-cell *matHeaderCellDef
                            translate> Max Courses
                        </th>
                        <td style="padding:0px;min-width: 80px;max-width: 80px;border:none;" mat-cell
                            *matCellDef="let element;let i = dataIndex"
                            [attr.rowspan]="getRowSpan(element)" [style.display]="element.RowNumber > 1 ? 'none' : ''">
                            <div
                                [ngStyle]="{'background-color':element.HighlightMaxCourses==true ? '#ffff8d' : '', 'color': element.ReqMaxCourses ? 'black' : 'lightgray' }"
                                style="height: 40px;width: 40px;text-align: center;padding-top: 10px;">
                                {{element.ReqMaxCourses ? element.ReqMaxCourses : "N/A"}}
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="RequestedCourses">
                        <th style="padding:0px;min-width: 80px;max-width: 80px;" mat-header-cell *matHeaderCellDef
                            translate> Requested Courses
                        </th>
                        <td style="padding:0px;min-width: 80px;max-width: 80px;" mat-cell
                            *matCellDef="let element;let i = dataIndex"
                            [attr.rowspan]="getRowSpan(element)" [style.display]="element.RowNumber > 1 ? 'none' : ''">
                            <div
                                [ngStyle]="{'background-color':element.HighlightMinCourses==true || element.HighlightMaxCourses==true ? '#ffff8d' : ''}"
                                style="height: 40px;width: 40px;text-align: center;padding-top: 10px;">
                                {{element.RequestedCourses}}
                            </div>

                        </td>
                    </ng-container>

                    <ng-container matColumnDef="CRType">
                        <th style="padding:0px;width:5%;border-left:1px solid black;" mat-header-cell *matHeaderCellDef
                            translate> Type
                        </th>
                        <td style="padding:0px;width:5%;border-left:1px solid black;border-bottom: none;" mat-cell
                            *matCellDef="let data;let i = dataIndex">
                            <img [src]="data.imageUrl" style="margin-left: 15px;"
                                *ngIf="data.isHiddenRow == false && data.ParentCR_ID != 0"/>
                            <tyl-form-field style="width:90%;max-width: 100px;"
                                *ngIf="data.isHiddenRow == false && data.ParentCR_ID == 0">
                                <mat-select id='ddlCRType{{i}}' [(ngModel)]="data.CRType"
                                [disabled]="(!counselor && (data.RequirementName == 'No Requirement' || data.Status == 'A' || data.RequirementType == 1)) || (counselor && data.RequirementType == 1)">
                                    <mat-option value='Primary'>Primary</mat-option>
                                    <mat-option value='Alternate' *ngIf="data.AllowGlobalAlternates == true">Alternate
                                    </mat-option>
                                </mat-select>
                            </tyl-form-field>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="Credits_Course">
                        <th style="padding:0px;width:15%;" mat-header-cell *matHeaderCellDef translate> [Credits]
                            Course
                        </th>
                        <td style="padding:0px;width:15%;border:none;" mat-cell
                            *matCellDef="let data;let i = dataIndex">
                            <tyl-form-field style="width:90%;max-width: 200px;" *ngIf="data.isHiddenRow == false">
                                <mat-select #ddlCRCourse
                                    id='ddlCRCourse{{data.DistrictRequirement_ID}}{{data.RowNumber}}'
                                    [compareWith]="compareObjects"
                                    [(ngModel)]="data.DistrictCourse_ID" (selectionChange)="courseChange(data)"
                                    [disabled]="(!counselor && (data.RequirementName == 'No Requirement' || data.Status == 'A' || data.RequirementType == 1)) || (counselor && data.RequirementType == 1)">
                                    <mat-option
                                        *ngFor="let course of courseOptions | scrCourseFilter : data.DistrictRequirement_ID"
                                        [value]="course.ValueField">
                                        {{course.TextField}}
                                    </mat-option>
                                </mat-select>
                            </tyl-form-field>

                        </td>
                    </ng-container>

                    <ng-container matColumnDef="PreferredTerm">
                        <th style="padding:0px;width:5%;" mat-header-cell *matHeaderCellDef translate> Term</th>
                        <td style="padding:0px;width:5%;border:none;" mat-cell *matCellDef="let data; let i = dataIndex">
                            <tyl-form-field style="width: 90%;max-width:100px;"
                                *ngIf="termPolicy.CanEdit && data.isHiddenRow == false">
                                <mat-select id="ddlTerms{{i}}" [compareWith]="compareObjects"
                                    [(ngModel)]="data.PreferredTerm" (selectionChange)="setCreditIndicators()"
                                    [disabled]="!counselor && (!termPolicy.CanEdit || data.RequirementName == 'No Requirement' || data.Status == 'A')">
                                    <mat-option
                                        *ngFor="let term of termOptions | scrTermFilter : data.DistrictRequirement_ID : data.DistrictCourse_ID"
                                        [value]="term.TextField">
                                        {{term.TextField}}
                                    </mat-option>
                                </mat-select>
                            </tyl-form-field>
                            <div *ngIf="termPolicy.CanEdit == false" style="width: 90%;max-width:100px;">
                                <span>{{data.PreferredTerm}}</span>
                            </div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="PreferredPeriod">
                        <th style="padding:0px;width:5%;" mat-header-cell *matHeaderCellDef translate> Period</th>
                        <td style="padding:0px;width:5%;border:none;" mat-cell *matCellDef="let data;let i = dataIndex">
                            <tyl-form-field style="width:90%;max-width: 80px;"
                                *ngIf="periodPolicy.CanEdit && data.isHiddenRow == false">
                                <mat-select id='ddlPeriod{{i}}' [compareWith]="compareObjects"
                                    [(ngModel)]="data.PreferredPeriod"
                                    [disabled]="!counselor && (!periodPolicy.CanEdit || data.RequirementName == 'No Requirement' || data.Status == 'A')">
                                    <mat-option
                                        *ngFor="let period of periodsOptions  | scrPeriodFilter : data.DistrictRequirement_ID : data.DistrictCourse_ID: data.PreferredPeriod"
                                        [value]="period.TextField">
                                        {{period.TextField}}
                                    </mat-option>
                                </mat-select>
                            </tyl-form-field>
                            <div *ngIf="periodPolicy.CanEdit == false" style="width:90%;max-width: 80px;">
                                <span>{{data.PreferredPeriod}}</span>
                            </div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="PreferredTeacher">
                        <th style="padding:0px;width:10%;" mat-header-cell *matHeaderCellDef translate> Teacher</th>
                        <td style="padding:0px;width:10%;border:none;" mat-cell
                            *matCellDef="let data;let i = dataIndex">
                            <tyl-form-field *ngIf="teacherPolicy.CanEdit && data.isHiddenRow == false"
                                style="width:90%;max-width: 180px;">
                                <mat-select id='ddlTeacher{{i}}' [compareWith]="compareObjects"
                                    [(ngModel)]="data.PreferredTeacher"
                                    [disabled]="!counselor && (!teacherPolicy.CanEdit || data.RequirementName == 'No Requirement' || data.Status == 'A')">
                                    <mat-option
                                        *ngFor="let teacher of teacherOptions  | scrTeacherFilter : data.DistrictRequirement_ID : data.DistrictCourse_ID : data.PreferredTeacher : data.PreferredTeacherNameSetByCounselor"
                                        [value]="teacher.ValueField">
                                        {{teacher.TextField}}
                                    </mat-option>
                                </mat-select>
                            </tyl-form-field>
                            <div *ngIf="!teacherPolicy.CanEdit" style="width:90%;max-width: 180px;">
                                <span>
                                    {{data.PreferredTeacherNameSetByCounselor}}
                                </span>
                            </div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="Conflicts">
                        <th style="padding:0px;min-width:70px;max-width: 70px;" mat-header-cell *matHeaderCellDef
                            translate> Conflicts
                        </th>
                        <td style="padding:0px;min-width:70px;max-width: 70px;border:none;" mat-cell
                            *matCellDef="let data;let i = dataIndex">
                            <span *ngIf="data.isHiddenRow == false">{{ data.Conflicts }}</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <th style="padding:0px;min-width:70px;max-width: 70px;" mat-header-cell *matHeaderCellDef
                            translate>Actions
                        </th>
                        <td style="padding:0px;min-width:70px;max-width: 70px;border:none;" mat-cell
                            *matCellDef="let data;let i = dataIndex">
                            <div *ngIf="data.isHiddenRow == false || data.RowNumber == 1">
                                <tyl-mat-menu image="actions.png" [showLabel]="false">
                                    <button mat-button class="menuItem" (click)="addRow(data,i)"
                                        *ngIf="data.ParentCR_ID == 0 && data.RequirementType != 1" translate>
                                        Add row
                                    </button>
                                    <button mat-button class="menuItem"
                                        (click)="addCourseSpecificAlternateRequest(data,i)"
                                        *ngIf="data.isHiddenRow == false && data.CRType == 'Primary' && data.AllowIndividualAlternates == true && data.RequirementType != 1 && data.StudentCourseRequest_ID > 0"
                                        translate>
                                        Add Alternate Request
                                    </button>
                                    <button mat-button class="menuItem" (click)="openCourseDescription(data,i)"
                                        *ngIf="data.isHiddenRow == false"
                                        translate>
                                        Course Description
                                    </button>
                                    <button mat-button class="menuItem" (click)="deleteCourseRequest(data,i)"
                                        *ngIf="(data.Status != 'A' && data.isHiddenRow == false && data.RequirementType != 1) || (data.isHiddenRow == false && counselor && data.RequirementType != 1)"
                                        translate>
                                        Delete
                                    </button>
                                </tyl-mat-menu>
                            </div>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="ColumnsToDisplay;sticky: true;" style="padding:0px;"></tr>
                    <tr mat-row *matRowDef="let row; columns: ColumnsToDisplay;" (mouseenter)="hoverRow(row) "
                        (mouseleave)="removehoverRow()"
                        style="padding:0px;"
                        [ngStyle]="{'border-top':row.RowNumber == 1 ? '1px solid black' : '1px solid rgba(0, 0, 0, 0.12)','background-color':row.isHover == true ? '#EEEEEE' : 'white'}"></tr>

                </table>
            </div>
        </div>
    </div>
</tyl-kendo-pdf-export>
<div #footer class="flex-footer">
    <div class="flex-footer-left">
        <tyl-button *ngIf="userType == 1" image="notes.png" label="Course Request Management"
            (clickEvent)="redirect('CourseRequestManagement')"></tyl-button>
        <div *ngIf="false">
            <tyl-button image="{{IsFiltered ? 'filter yellow.png' : 'filter.png'}}" label="Filter"
                (clickEvent)="openFilter()"></tyl-button>
        </div>
    </div>
    <div class="flex-footer-middle">
        <tyl-mat-menu image="tools.png"
            label="Tools"
            style="align-self: center"
            *ngIf="counselor"
            [topMenuItems]="toolsMenuItems"
            (menuClick)="toolsMenuItemClick($event)"></tyl-mat-menu>
    </div>
    <div class="flex-footer-right" style="align-items: center;">
        <error-prompt [errorList]="errors"></error-prompt>
        <tyl-button image="save black.png" label="Save" (clickEvent)="validateAndSave()"></tyl-button>
    </div>
</div>
